import { Fragment } from 'react';
import { MdCloudDone } from 'react-icons/md';
import { toast } from 'react-toastify';
export const toastRequestSuccess = (json) => {
    toast.success(<Fragment>成功</Fragment>, {
        icon: (<MdCloudDone color='green' size={'lg'}/>),
    });
};
